import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { InputAdornment, Box, Typography, TextField } from '@mui/material';
import generator from 'generate-password-browser';
import { Autocomplete } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { toast } from 'react-toastify';

import api from '../../services/api';
import { Title } from '../../components/atoms/title';
import { useUniversities } from '../../hooks/universities';

const schema = yup
  .object({
    full_name: yup.string().required('O nome do parceiro é obrigatório').trim(),
    name: yup.string().required('O usuário do parceiro é obrigatório').trim(),
    password: yup.string().optional().trim(),
  })
  .required();

export function PartnerEdit() {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      full_name: '',
      name: '',
      password: generator.generate({
        length: 10,
        numbers: true,
      }),
    },

    resolver: yupResolver(schema),
  });

  const [loading, setLoading] = useState(false);

  const [type, setType] = useState('');
  const [university, setUniversity] = useState('');
  const { universities, partners } = useUniversities();

  const [partnerId, setPartnerId] = useState(null);

  const handleEditPartner = async formData => {
    try {
      setLoading(true);

      const updatedPartner = {
        partner_id: partnerId,
        ...formData,
        university,
      };

      if (!formData.password) {
        delete updatedPartner.password;
      }

      await api.put(`/partners/${partnerId}`, {
        ...formData,
        university,
      });

      reset();
      setPartnerId(null);
      setUniversity('');
      setType('');

      toast('Informações alteradas com sucesso!', { type: 'success' });
    } catch (error) {
      toast('Erro ao alterar as informações', { type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid spacing={2} container>
      <Grid item>
        <Title>Edição de Parceiros</Title>
      </Grid>

      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid xs={12} item>
            <Autocomplete
              id='combo-box-demo'
              options={partners}
              disabled={universities.length === 0}
              getOptionLabel={option => option.name}
              getOptionKey={option => option.id}
              onChange={(_e, value) => {
                if (value && value.name) {
                  setValue('name', value.name);
                  setValue('full_name', value.full_name);
                  setValue('password', '');

                  setPartnerId(value.id);
                  setUniversity(value.university);
                  setType(value.type);
                } else {
                  reset();
                  setUniversity(null);
                  setPartnerId(null);
                }
              }}
              renderInput={params => <TextField {...params} placeholder='Parceiro' variant='outlined' />}
            />
          </Grid>
          {partnerId && (
            <>
              <Grid xs={12} md={6} item>
                <TextField
                  required
                  id='full_name'
                  name='full_name'
                  label='Nome'
                  fullWidth
                  margin='dense'
                  variant='outlined'
                  {...register('full_name')}
                  error={!!errors.full_name}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <Typography variant='inherit' color='textSecondary'>
                  {errors.full_name?.message}
                </Typography>
              </Grid>

              <Grid xs={12} md={6} item>
                <Autocomplete
                  id='combo-box-demo'
                  options={universities}
                  defaultValue={universities.find(item => item.name === university)}
                  getOptionLabel={option => option.name}
                  getOptionKey={option => option.id}
                  onChange={(_e, value) => {
                    if (value?.name) {
                      setUniversity(value.name);
                    } else {
                      setUniversity('');
                    }
                  }}
                  renderInput={params => <TextField {...params} placeholder='Universidade' variant='outlined' />}
                />
              </Grid>

              <Grid xs={12} md={6} item>
                <TextField
                  required
                  id='password'
                  name='password'
                  label='Senha'
                  fullWidth
                  margin='dense'
                  variant='outlined'
                  {...register('password')}
                  error={!!errors.password}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment
                        onClick={() => {
                          setValue(
                            'password',
                            generator.generate({
                              length: 10,
                              numbers: true,
                            })
                          );
                        }}
                        position='start'
                      >
                        <LockIcon style={{ cursor: 'pointer' }} fontSize='small' />
                      </InputAdornment>
                    ),
                  }}
                />
                <Typography variant='inherit' color='textSecondary'>
                  {errors.password?.message}
                </Typography>
              </Grid>

              <Grid xs={12} md={6} item>
                <TextField disabled label='Tipo' fullWidth margin='dense' variant='outlined' value={type} />
              </Grid>
            </>
          )}
        </Grid>
      </Grid>

      <Box m='auto' mt={3}>
        <Button
          disabled={loading}
          type='submit'
          variant='contained'
          color='primary'
          onClick={handleSubmit(handleEditPartner)}
        >
          {loading ? 'Salvando...' : 'Salvar'}
        </Button>
      </Box>
    </Grid>
  );
}
